// src/perametric/widgets/FormulaRow.jsx
import React from "react";

const FormulaRow = ({ row, onChange }) => {
  return (
    <div style={{ display: "flex", gap: "6px", marginBottom: "6px", }}>
      <input
        type="text"
        placeholder="key"
        value={row.key || ""}
        onChange={(e) => onChange({ ...row, key: e.target.value })}
        style={inputStyleSmall}
      />
      <input
        type="text"
        placeholder="expression"
        value={row.expression || ""}
        onChange={(e) => onChange({ ...row, expression: e.target.value })}
        style={inputStyleWide}
      />
    </div>
  );
};

const inputStyleSmall = {
  width: "70px",
  padding: "4px",
  backgroundColor: "#2a2a2a",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "3px",
};

const inputStyleWide = {
  width: "280px",
  padding: "4px",
  backgroundColor: "#2a2a2a",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "3px",
};

export default FormulaRow;
